export const getFileExtension = (file: string): string => {
  return file.substring(file.lastIndexOf(".") + 1);
};
